<template>
  <aside class="hidden lg:block w-[285px] pr-6 relative">
    <nav class="space-y-2 sticky top-[100px]">
      <RouterLink
        class="inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start"
        :to="{ name: 'feed' }" :active-class="'bg-accent'">
        <component :is="GlobeIcon" class="h-5 w-5 mr-2" />
        Explorar
      </RouterLink>
      <RouterLink
        v-if="hasRoles([AclEnum.PRODUCER, AclEnum.ADMIN]) && tenant?.id === 1 || hasRoles([AclEnum.ADMIN_MEMBER_AREA])"
        class="inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start"
        :to="{ name: 'courses.communities.create' }" :active-class="'bg-accent'">
        <component :is="FolderPlusIcon" class="h-5 w-5 mr-2" />
        Adicionar comunidade
      </RouterLink>
      <template v-if="!communities">
        <a v-for="i in 5" :key="i" class="inline-flex h-10 px-4 py-2 w-full rounded-md animate-pulse bg-accent/20"></a>
      </template>
      <template v-else-if="communities && communities.length > 0">
        <div v-for="community in communities" :key="community.id" class="group flex items-center justify-between gap-1">
          <RouterLink
            class="truncate inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start"
            :active-class="'bg-accent'"
            :to="{ name: 'courses.communities.show', params: { courseId: community.courseId, communityId: community.id } }">
            {{ community.name }}
          </RouterLink>
          <button v-if="canDeleteCommunity(community)" @click.stop.prevent="openDeleteModal(community.id, community.courseId)"
            class="p-2 text-muted-foreground hover:text-destructive transition-all"
            title="Excluir comunidade">
            <Trash2 class="h-4 w-4" />
          </button>
        </div>
      </template>
      <div v-else class="px-4 py-2">
        <p class="text-xs text-zinc-500 italic">Nenhuma comunidade ainda</p>
      </div>
    </nav>
  </aside>
  <Sheet>
    <SheetTrigger as-child>
      <button v-if="!$route.path.includes('/topic')"
        class="bg-background border shrink-0 md:hidden fixed rounded-full bottom-20 sm:bottom-5 right-4 p-5">
        <Menu class="h-5 w-5" />
        <span class="sr-only">Toggle navigation menu</span>
      </button>
    </SheetTrigger>
    <SheetContent side="left">
      <nav class="grid gap-4 text-lg font-medium pt-8">
        <RouterLink
          class="inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start"
          :to="{ name: 'feed' }" :active-class="'bg-accent'">
          <component :is="GlobeIcon" class="h-5 w-5 mr-2" />
          Explorar
        </RouterLink>
        <RouterLink
          v-if="hasRoles([AclEnum.PRODUCER, AclEnum.ADMIN]) && tenant?.id === 1 || hasRoles([AclEnum.ADMIN_MEMBER_AREA])"
          class="inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start"
          :to="{ name: 'courses.communities.create' }" :active-class="'bg-accent'">
          <component :is="FolderPlusIcon" class="h-5 w-5 mr-2" />
          Adicionar comunidade
        </RouterLink>
        <template v-if="!communities">
          <a v-for="i in 5" :key="i"
            class="inline-flex h-10 px-4 py-2 w-full rounded-md animate-pulse bg-accent/20"></a>
        </template>
        <template v-else-if="communities && communities.length > 0">
          <div v-for="community in communities" :key="community.id"
            class="group flex items-center justify-between gap-1">
            <RouterLink
              class="truncate inline-flex items-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-accent hover:text-accent-foreground h-10 px-4 py-2 w-full justify-start"
              :active-class="'bg-accent'"
              :to="{ name: 'courses.communities.show', params: { courseId: community.courseId, communityId: community.id } }">
              {{ community.name }}
            </RouterLink>
            <button v-if="canDeleteCommunity(community)"
              @click.stop.prevent="openDeleteModal(community.id, community.courseId)"
              class="p-2 text-muted-foreground hover:text-destructive transition-all" title="Excluir comunidade">
              <Trash2 class="h-4 w-4" />
            </button>
          </div>
        </template>
        <div v-else class="px-4 py-2">
          <p class="text-xs text-zinc-500 italic">Nenhuma comunidade ainda</p>
        </div>
      </nav>
    </SheetContent>
  </Sheet>

  <Dialog v-model:open="isDeleteDialogOpen">
    <DialogContent class="sm:max-w-[425px] bg-zinc-950 border-zinc-800 text-white">
      <DialogHeader>
        <DialogTitle class="text-xl font-bold">Excluir Comunidade</DialogTitle>
        <DialogDescription class="text-zinc-400">
          Você tem certeza que deseja excluir esta comunidade? Esta ação é irreversível e removerá todos os tópicos e
          publicações associados.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter class="mt-6 flex gap-2">
        <Button variant="ghost" @click="isDeleteDialogOpen = false" class="hover:bg-zinc-800">
          Cancelar
        </Button>
        <Button variant="destructive" @click="handleConfirmDelete" :disabled="isDeleting">
          {{ isDeleting ? 'Excluindo...' : 'Excluir' }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import Button from '@/components/ui/button/Button.vue';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useAuth } from '@/composables/useAuth';
import { useAxios } from '@/composables/useAxios';
import { AclEnum } from '@/enums/acl/AclEnum';
import { communities } from '@/states/communities';
import { FolderPlusIcon, GlobeIcon, Menu, Trash2 } from 'lucide-vue-next';
import { onMounted, ref } from 'vue';
import { useTenant } from '@/composables/useTenant'
import { useToast } from '@/components/ui/toast';

const { tenant } = useTenant()
const { hasRoles, organization, userAuthenticated } = useAuth()
const axios = useAxios()
const { toast } = useToast()
const router = useRouter()

const isDeleteDialogOpen = ref(false)
const communityToDelete = ref<{ id: number, courseId: number } | null>(null)
const isDeleting = ref(false)

function getCommunities() {
  axios.get('/courses/communities')
    .then((res) => {
      communities.value = res.data
    })
}

function canDeleteCommunity(community: any) {
  if (hasRoles([AclEnum.ADMIN_MEMBER_AREA])) return true;
  
  const isProducer = hasRoles([AclEnum.PRODUCER]);
  const isAdmin = hasRoles([AclEnum.ADMIN]);
  const isOwner = userAuthenticated.organizationIds?.some(id => String(id) == String(community.organizationId));
  
  if (isAdmin && tenant.value?.id === 1) return true;
  
  return (isProducer || isAdmin) && isOwner;
}

function openDeleteModal(id: number, courseId: number) {
  const community = communities.value?.find(c => c.id === id);
  if (community && !canDeleteCommunity(community)) {
    toast({
      title: 'Acesso negado',
      description: 'Você não tem permissão para excluir esta comunidade.',
      variant: 'destructive'
    })
    return;
  }
  
  communityToDelete.value = { id, courseId }
  isDeleteDialogOpen.value = true
}

function handleConfirmDelete() {
  if (communityToDelete.value) {
    const community = communities.value?.find(c => c.id === communityToDelete.value?.id);
    if (community && !canDeleteCommunity(community)) {
       toast({
        title: 'Acesso negado',
        variant: 'destructive'
      })
      isDeleteDialogOpen.value = false
      return;
    }

    isDeleting.value = true
    axios.delete(`/courses/${communityToDelete.value.courseId}/communities/${communityToDelete.value.id}`)
      .then(() => {
        toast({
          title: 'Comunidade excluída com sucesso',
          class: 'bg-green-500 text-white'
        })
        isDeleteDialogOpen.value = false
        getCommunities()
        router.push({ name: 'feed' })
      })
      .catch(() => {
        toast({
          title: 'Erro ao excluir comunidade',
          variant: 'destructive'
        })
      })
      .finally(() => {
        isDeleting.value = false
      })
  }
}

onMounted(() => {
  getCommunities()
})
</script>
